export default {
  supportedLngs: ["fr"],
  fallbackLng: "fr",
  defaultNS: "common",
}
